export interface Movie {
  id: string;
  title: string;
  poster: string;
  type: '电影' | '电视剧' | '综艺' | '动漫';
  genres: string[];
  region: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  synopsis: string;
}

export const movies: Movie[] = [
  {
    id: 'm01',
    title: '星际回响',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20featuring%20a%20lone%20astronaut%20before%20a%20giant%20glowing%20planet%2C%20warm%20amber%20and%20teal%20tones%2C%20dramatic%20lighting%2C%20clean%20poster%20layout%2C%20high%20detail&width=400&height=600&seq=peach-movie-01&orientation=portrait',
    type: '电影',
    genres: ['科幻', '冒险'],
    region: '欧美',
    year: 2025,
    rating: 8.7,
    duration: '138分钟',
    director: '陈逸舟',
    actors: ['林深', '苏晚', '周慕言'],
    synopsis:
      '人类首次深空跃迁实验意外唤醒了沉睡于星云中的未知信号，一名宇航员踏上孤独的回响之旅，在宇宙尽头寻找人类的另一种可能。',
  },
  {
    id: 'm02',
    title: '南方旧事',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20drama%20movie%20poster%20of%20a%20quiet%20southern%20town%20alley%20at%20sunset%2C%20amber%20and%20sepia%20tones%2C%20gentle%20light%2C%20minimal%20poster%20layout%2C%20high%20detail&width=400&height=600&seq=peach-movie-02&orientation=portrait',
    type: '电影',
    genres: ['剧情', '家庭'],
    region: '大陆',
    year: 2024,
    rating: 8.2,
    duration: '124分钟',
    director: '许南川',
    actors: ['何晚秋', '陆知远', '方听雨'],
    synopsis:
      '南方小城的旧巷里，一家三代人在时代变迁中守护着同一间老茶馆，关于离别、归来与和解的故事缓缓展开。',
  },
  {
    id: 'm03',
    title: '暗夜追凶',
    poster:
      'https://readdy.ai/api/search-image?query=Suspense%20crime%20thriller%20movie%20poster%20with%20rainy%20neon%20city%20street%20and%20shadowy%20figure%2C%20dark%20moody%20tones%20with%20orange%20accents%2C%20tense%20atmosphere%2C%20high%20detail&width=400&height=600&seq=peach-movie-03&orientation=portrait',
    type: '电影',
    genres: ['悬疑', '犯罪'],
    region: '香港',
    year: 2025,
    rating: 8.5,
    duration: '116分钟',
    director: '梁正霆',
    actors: ['程子谦', '温若曦', '郑伟豪'],
    synopsis:
      '一场持续十年的连环悬案迎来新的线索，退休刑警与年轻法医联手追查，真相却指向了彼此都无法承受的过往。',
  },
  {
    id: 'm04',
    title: '夏日放映厅',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20coming%20of%20age%20movie%20poster%20of%20a%20small%20outdoor%20cinema%20under%20summer%20sky%2C%20golden%20hour%20warm%20orange%20tones%2C%20dreamy%20bokeh%2C%20clean%20poster%20layout%2C%20high%20detail&width=400&height=600&seq=peach-movie-04&orientation=portrait',
    type: '电影',
    genres: ['爱情', '青春'],
    region: '大陆',
    year: 2024,
    rating: 7.9,
    duration: '108分钟',
    director: '苏浅',
    actors: ['夏知遥', '许星野', '安知夏'],
    synopsis:
      '海边小镇的露天放映厅里，两个年轻人因一部老电影相遇，在一个夏天里留下了关于梦想与初恋的温柔记忆。',
  },
  {
    id: 'm05',
    title: '雾都迷城',
    poster:
      'https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20film%20poster%20of%20a%20foggy%20old%20city%20skyline%20with%20a%20single%20silhouette%2C%20muted%20gray%20with%20warm%20amber%20glow%2C%20elegant%20composition%2C%20high%20detail&width=400&height=600&seq=peach-movie-05&orientation=portrait',
    type: '电影',
    genres: ['悬疑', '剧情'],
    region: '欧美',
    year: 2023,
    rating: 8.0,
    duration: '130分钟',
    director: '艾文·雷',
    actors: ['乔纳·凯', '米兰达·肖', '亚瑟·邓'],
    synopsis:
      '浓雾笼罩的旧城里，一名记者为调查一桩尘封旧案深入禁区，却发现整座城市的记忆都在被人为地改写。',
  },
  {
    id: 'm06',
    title: '山与海之约',
    poster:
      'https://readdy.ai/api/search-image?query=Epic%20adventure%20movie%20poster%20of%20rugged%20mountains%20meeting%20a%20vast%20sea%2C%20sweeping%20landscape%2C%20golden%20and%20deep%20teal%20tones%2C%20cinematic%20wide%20composition%2C%20high%20detail&width=400&height=600&seq=peach-movie-06&orientation=portrait',
    type: '电影',
    genres: ['冒险', '纪录'],
    region: '大陆',
    year: 2025,
    rating: 8.3,
    duration: '102分钟',
    director: '高原',
    actors: ['纪录片旁白 · 顾言'],
    synopsis:
      '一支探险队沿着古老的山海古道徒步三千公里，用镜头记录下变迁中的自然与人间烟火，兑现一场跨越山海的约定。',
  },
  {
    id: 'm07',
    title: '长夜将明',
    poster:
      'https://readdy.ai/api/search-image?query=Gritty%20period%20drama%20TV%20series%20poster%20of%20a%20city%20at%20dawn%20with%20warm%20rising%20sun%2C%20retro%20cinematic%20tones%2C%20orange%20and%20charcoal%20palette%2C%20high%20detail&width=400&height=600&seq=peach-movie-07&orientation=portrait',
    type: '电视剧',
    genres: ['年代', '剧情'],
    region: '大陆',
    year: 2025,
    rating: 8.9,
    duration: '全40集',
    director: '沈砚',
    actors: ['傅明川', '白念安', '贺清和'],
    synopsis:
      '上世纪三十年代的江城，一群年轻人在暗夜中追寻光亮，用热血与信念书写属于那个年代的觉醒与抉择。',
  },
  {
    id: 'm08',
    title: '都市微光',
    poster:
      'https://readdy.ai/api/search-image?query=Modern%20urban%20life%20drama%20TV%20poster%20of%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%2C%20cinematic%20bokeh%2C%20orange%20and%20slate%20tones%2C%20high%20detail&width=400&height=600&seq=peach-movie-08&orientation=portrait',
    type: '电视剧',
    genres: ['都市', '情感'],
    region: '大陆',
    year: 2024,
    rating: 7.8,
    duration: '全36集',
    director: '苏浅',
    actors: ['林一诺', '陆行舟', '顾小满'],
    synopsis:
      '四个在都市打拼的年轻人相遇于同一栋老楼，他们在工作、爱情与生活之间互相照亮，寻找属于自己的那束微光。',
  },
  {
    id: 'm09',
    title: '长安夜行录',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20poster%20of%20ancient%20lantern-lit%20palace%20at%20night%2C%20rich%20amber%20and%20deep%20red%20tones%2C%20ornate%20details%2C%20high%20detail&width=400&height=600&seq=peach-movie-09&orientation=portrait',
    type: '电视剧',
    genres: ['古装', '奇幻'],
    region: '大陆',
    year: 2025,
    rating: 8.6,
    duration: '全48集',
    director: '顾长风',
    actors: ['谢无尘', '云清歌', '裴照夜'],
    synopsis:
      '盛唐夜色之下，一名巡夜人卷入诡谲谜案，与神秘少女携手揭开笼罩长安城百年的隐秘。',
  },
  {
    id: 'm10',
    title: '海岸侦探社',
    poster:
      'https://readdy.ai/api/search-image?query=Bright%20mystery%20comedy%20TV%20poster%20of%20a%20sunny%20coastal%20town%20with%20a%20vintage%20detective%20office%2C%20cheerful%20turquoise%20and%20warm%20orange%20tones%2C%20high%20detail&width=400&height=600&seq=peach-movie-10&orientation=portrait',
    type: '电视剧',
    genres: ['悬疑', '喜剧'],
    region: '日韩',
    year: 2024,
    rating: 8.1,
    duration: '全12集',
    director: '吉田亮',
    actors: ['佐藤健一', '小林凛', '中村优子'],
    synopsis:
      '濒临倒闭的海岸侦探社迎来一位古怪新人，两人在一桩桩看似鸡毛蒜皮的小案子里，意外拼出小镇的秘密全貌。',
  },
  {
    id: 'm11',
    title: '云端之上',
    poster:
      'https://readdy.ai/api/search-image?query=Inspirational%20workplace%20drama%20TV%20poster%20of%20glass%20skyscrapers%20above%20clouds%20at%20sunrise%2C%20optimistic%20golden%20tones%2C%20clean%20modern%20composition%2C%20high%20detail&width=400&height=600&seq=peach-movie-11&orientation=portrait',
    type: '电视剧',
    genres: ['职场', '励志'],
    region: '大陆',
    year: 2025,
    rating: 8.0,
    duration: '全32集',
    director: '孟之遥',
    actors: ['江承宇', '莫以宁', '许知微'],
    synopsis:
      '一名来自小城的实习生闯入顶级科技公司，在大厂浮沉与理想碰撞中，学会把技术写进真正需要的天空里。',
  },
  {
    id: 'm12',
    title: '大江奔流',
    poster:
      'https://readdy.ai/api/search-image?query=Historical%20epic%20TV%20poster%20of%20a%20mighty%20river%20through%20mountains%20at%20golden%20hour%2C%20sweeping%20scale%2C%20amber%20and%20earth%20tones%2C%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=peach-movie-12&orientation=portrait',
    type: '电视剧',
    genres: ['历史', '剧情'],
    region: '大陆',
    year: 2023,
    rating: 8.4,
    duration: '全45集',
    director: '沈砚',
    actors: ['程致远', '林书瑶', '顾仲卿'],
    synopsis:
      '沿江三座城市四十年的沧桑巨变，浓缩在几个普通家庭的命运里，见证一条大河的奔流与一个时代的脉搏。',
  },
  {
    id: 'm13',
    title: '厨房欢乐颂',
    poster:
      'https://readdy.ai/api/search-image?query=Fun%20cooking%20reality%20show%20poster%20of%20a%20warm%20kitchen%20with%20colorful%20fresh%20ingredients%2C%20playful%20orange%20and%20cream%20tones%2C%20appetizing%20food%20photography%2C%20high%20detail&width=400&height=600&seq=peach-movie-13&orientation=portrait',
    type: '综艺',
    genres: ['美食', '真人秀'],
    region: '大陆',
    year: 2025,
    rating: 8.2,
    duration: '每周五更新',
    director: '总导演 · 冯甜',
    actors: ['嘉宾 · 陆知远', '嘉宾 · 顾小满', '嘉宾 · 方听雨'],
    synopsis:
      '八位来自不同领域的嘉宾走进同一间厨房，用一道道家常菜展开温暖又爆笑的味觉比拼，寻找最治愈的人间烟火。',
  },
  {
    id: 'm14',
    title: '城市漫游记',
    poster:
      'https://readdy.ai/api/search-image?query=Travel%20variety%20show%20poster%20of%20a%20charming%20old%20city%20street%20with%20cafes%20and%20bicycles%2C%20sunny%20warm%20orange%20tones%2C%20lively%20atmosphere%2C%20high%20detail&width=400&height=600&seq=peach-movie-14&orientation=portrait',
    type: '综艺',
    genres: ['旅行', '纪实'],
    region: '大陆',
    year: 2024,
    rating: 8.3,
    duration: '全10期',
    director: '总导演 · 秦朗',
    actors: ['常驻 · 苏浅', '常驻 · 陆行舟', '飞行 · 贺清和'],
    synopsis:
      '一群好友用脚步丈量城市，走街串巷探访本地人的隐秘角落，在慢下来的旅行里重新发现生活的温度。',
  },
  {
    id: 'm15',
    title: '声音对决',
    poster:
      'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20of%20a%20stage%20with%20warm%20spotlights%20and%20silhouettes%2C%20energetic%20orange%20and%20magenta%20accents%2C%20dynamic%20composition%2C%20high%20detail&width=400&height=600&seq=peach-movie-15&orientation=portrait',
    type: '综艺',
    genres: ['音乐', '竞演'],
    region: '大陆',
    year: 2025,
    rating: 7.9,
    duration: '每周六更新',
    director: '总导演 · 韩铮',
    actors: ['导师 · 云清歌', '导师 · 江承宇', '主持 · 莫以宁'],
    synopsis:
      '不同声音领域的歌手同台竞技，用改编与原创碰撞出火花，在舞台上争夺属于这个夏天的最强对决。',
  },
  {
    id: 'm16',
    title: '星轨少年',
    poster:
      'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20of%20a%20young%20boy%20standing%20on%20a%20rooftop%20under%20a%20star-filled%20sky%2C%20warm%20orange%20and%20deep%20indigo%20tones%2C%20vibrant%20illustration%2C%20high%20detail&width=400&height=600&seq=peach-movie-16&orientation=portrait',
    type: '动漫',
    genres: ['热血', '科幻'],
    region: '日韩',
    year: 2025,
    rating: 8.8,
    duration: '全24话',
    director: '新海·凛',
    actors: ['声演 · 佐藤健一', '声演 · 小林凛'],
    synopsis:
      '少年在废弃天文台遇见一颗坠落的星，从此获得绘制星轨的力量，为守护小镇的夜空踏上冒险旅程。',
  },
  {
    id: 'm17',
    title: '森林小厨神',
    poster:
      'https://readdy.ai/api/search-image?query=Cozy%20anime%20poster%20of%20an%20animal%20chef%20in%20a%20magical%20forest%20kitchen%2C%20warm%20amber%20and%20soft%20green%20tones%2C%20charming%20illustration%2C%20high%20detail&width=400&height=600&seq=peach-movie-17&orientation=portrait',
    type: '动漫',
    genres: ['治愈', '奇幻'],
    region: '欧美',
    year: 2024,
    rating: 8.5,
    duration: '全16话',
    director: '艾拉·格林',
    actors: ['声演 · 乔纳·凯', '声演 · 米兰达·肖'],
    synopsis:
      '会说话的小动物在森林里开了一家深夜食堂，用一道道魔法料理治愈每一位慕名而来的旅人。',
  },
  {
    id: 'm18',
    title: '剑与江湖',
    poster:
      'https://readdy.ai/api/search-image?query=Chinese%20wuxia%20anime%20poster%20of%20a%20swordsman%20on%20a%20misty%20mountain%20peak%2C%20dramatic%20ink%20and%20amber%20tones%2C%20heroic%20smoky%20atmosphere%2C%20high%20detail&width=400&height=600&seq=peach-movie-18&orientation=portrait',
    type: '动漫',
    genres: ['武侠', '国风'],
    region: '大陆',
    year: 2025,
    rating: 8.6,
    duration: '全26话',
    director: '顾长风',
    actors: ['声演 · 谢无尘', '声演 · 云清歌'],
    synopsis:
      '少年背剑下山，卷入江湖恩怨，在快意恩仇与家国大义之间，寻得剑道与人心的真正答案。',
  },
];